import { Box, Grid, Skeleton, Stack } from "@mui/material"

export const SkeletonVelesGeoProjectDetails = () => {
    return (
        <Box m={3}>
            <Grid container display={'flex'} flexDirection={'row'}>
                <Grid item xs={4}>
                    <Stack spacing={2}>
                        <Skeleton animation="wave" variant="rectangular" width={300} height={55} />
                        <Skeleton animation="wave" variant="rectangular" width={300} height={55} />
                        <Skeleton animation="wave" variant="rectangular" width={300} height={55} />
                        <Skeleton animation="wave" variant="rectangular" width={300} height={55} />
                        <Skeleton animation="wave" variant="rectangular" width={300} height={55} />
                        <Skeleton animation="wave" variant="rectangular" width={300} height={55} />
                    </Stack>
                </Grid>

                <Grid item xs={8}>
                    <Stack spacing={1}>
                        <Skeleton animation="wave" variant="text" width={400} />
                        <Skeleton animation="wave" variant="text" width={400} />
                        <Skeleton animation="wave" variant="text" width={400} />
                        <Skeleton animation="wave" variant="text" width={400} />
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    )
}